// ~/compta-app/client/src/components/Dashboard/Dashboard.js
import React from 'react';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <h1>Tableau de Bord</h1>

    </div>
  );
};

export default Dashboard;
